import {GetPaymentTypeEnumApiResponse} from '@dms/api/core';

export const paymentTypesMock: GetPaymentTypeEnumApiResponse = [
  {
    key: 'bank_transfer',
    value: 'Bank transfer',
  },
  {
    key: 'cash',
    value: 'Cash',
  },
  {
    key: 'payment_card',
    value: 'Payment card',
  },
  {
    key: 'free_of_charge',
    value: 'Free of charge',
  },
  {
    key: 'offset',
    value: 'Offset',
  },
];
